/**
 * ExitRoom.js
 * 
 * This is the component which helps user to exit an entered room
 */

import { useNavigate } from "react-router-dom"
import Button from "../ui/Button"
import { DoorOpen } from "lucide-react";

/**
 * 
 * @returns {JSX.Element}   -   A rounded button with exit door icon to go to the games page
 */
const ExitRoom = () => {
    const navigate = useNavigate();
    return (
        <div className="items-end justify-end">
            <Button
                onClick={() => navigate('/games')}
                variant="main"
                className="
                    w-14 h-14                     /* equal width & height for perfect circle */
                    flex items-end justify-end
                    rounded-full
                    bg-zinc-900 text-white
                    shadow-lg hover:shadow-emerald-500/20 hover:bg-zinc-800
                    transition-all duration-300
                    mb-4
                "
            >
                <DoorOpen className="w-7 h-7" />
            </Button>
        </div>
    )
}

export default ExitRoom;